import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';


import { NoteEndpoint } from './note-endpoint.service';
import { Roles } from '../models/enums';




@Injectable({ providedIn: 'root'})
export class NoteService {

  constructor(private router: Router, private http: HttpClient, private noteEndpoint: NoteEndpoint) {

  }

  getNotesByAbstractProtocolId(abstractId?: number, protocolId?: number, activeRole?: Roles) {
    return this.noteEndpoint.getNotesByAbstractProtocolIdEndpoint<any[]>(abstractId, protocolId, activeRole);
  }

  getNoteByParentId(noteId?: number) {
    return this.noteEndpoint.getNotesByParentIdEndpoint<any[]>(noteId);
  }


  addNote(note: any) {
    return this.noteEndpoint.addNoteEndpoint<any>(note);
  }

}
